import React, { useState, useEffect } from "react";

const WebViewComponent = ({ sendMessageToRN }) => {
  const [authSetupjsonData, setAuthSetupjsonData] = useState(null);
  const [enrollmentData, setEnrollmentData] = useState(null);

  useEffect(() => {
    // Function to handle messages from React Native
    const onMessageFromRN = async (message) => {
      const { action, payload: cardInfo } = JSON.parse(message);

      // get ip address
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      const ipAddress = data.ip;

      // Function to handle card info submission
      const handleCardInfo = async (cardInfo) => {
        const { cardType, cardNumber, expYear, expMonth, currency } = cardInfo;
        const url = "https://pay.rafikii.io/api/v1/card/getPayAuthToken";

        const enrollData = {
          cardType,
          cardNumber,
          expYear,
          expMonth,
          currency,
        };

        try {
          const response = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(enrollData),
          });
          const data = await response.json();

          if (data.isValid) {
            sendMessageToRN({
              action: "token-fetch-success",
              payload: { data, error: null },
            });

            setAuthSetupjsonData(data);

            createCardinalCollectionIframe(data);
          }
        } catch (error) {
          console.error("Error fetching token:", error);
          sendMessageToRN({
            action: "token-fetch-fail",
            payload: { data: null, error },
          });
        }
      };

      // Function to create iframe for card collection
      const createCardinalCollectionIframe = (authData) => {
        const iframe = document.createElement("iframe");
        iframe.width = "10";
        iframe.height = "10";
        iframe.style.display = "none";

        iframe.name = "collectionIframe";
        iframe.id = "cardinal_collection_iframe";

        const dataCollectionDiv = document.getElementById(
          "dataCollectionIframe",
        );
        if (dataCollectionDiv) {
          dataCollectionDiv.appendChild(iframe);
        }

        // Create form for data collection
        const iframeForm = document.createElement("form");
        iframeForm.id = "cardinal_collection_form";
        iframeForm.target = "collectionIframe";
        iframeForm.method = "POST";
        iframeForm.action =
          "https://centinelapi.cardinalcommerce.com/V1/Cruise/Collect";

        const collectionInput = document.createElement("input");
        collectionInput.id = "cardinal_collection_form_input";
        collectionInput.name = "JWT";
        collectionInput.type = "hidden";
        collectionInput.value = authData.accessToken;

        iframeForm.appendChild(collectionInput);
        if (dataCollectionDiv) {
          dataCollectionDiv.appendChild(iframeForm);
        }
        iframeForm.submit();

        // Listen for message from the form collection
        window.addEventListener("message", (event) =>
          handleMessageFromIframe(event, authData),
        );
      };

      // Function to handle messages from the iframe
      const handleMessageFromIframe = async (event, authSetupjsonData) => {
        if (event.origin === "https://v256.rafikii.io") {
          const finalData = JSON.parse(event.data);

          sendMessageToRN({
            action: "message-from-return-url",
            payload: { data: finalData, error: null },
          });

          // remove the iframe & show loader animation
          const otpIframeDiv = document.getElementById("otpIframeDiv");
          const otpIframe = document.getElementById("step-up-iframe");
          otpIframeDiv.style = "display: none;";
          document.body.style = "background-color: rgba(62, 78, 112, 1);";

          const loaderEl = document.getElementById("loader");
          loaderEl.style = "display: contents;";

          sendMessageToRN({
            action: "otp-iframe-invisible",
            payload: {
              data: { message: "show the loader animation" },
              error: null,
            },
          });

          // handle response codes
          switch (finalData.code) {
            case 200:
              sendMessageToRN({
                action: "success",
                payload: { data: finalData, error: null },
              });
              break;
            case 201:
              sendMessageToRN({
                action: "fail",
                payload: { data: finalData, error: null },
              });
              break;
            case 214:
              sendMessageToRN({
                action: "fail",
                payload: { data: finalData, error: null },
              });
              break;
            case 221:
              sendMessageToRN({
                action: "fail",
                payload: { data: finalData, error: null },
              });
              break;
            default:
              sendMessageToRN({
                action: "fail",
                payload: { data: finalData, error: null },
              });
              break;
          }
        }

        if (event.origin === "https://centinelapi.cardinalcommerce.com") {
          const profileData = JSON.parse(event.data);

          sendMessageToRN({
            action: "profile-data-success",
            payload: { data: profileData, error: null },
          });

          if (profileData.Status) {
            // Profile completed

            const chkenrollmenturl =
              "https://pay.rafikii.io/api/v1/card/checkEnrollment";

            const checkEnrollmentData = {
              // actual card will be used here
              cardNumber: cardInfo.cardNumber,
              expYear: cardInfo.expYear,
              expMonth: cardInfo.expMonth,
              cardType: cardInfo.cardType,
              currency: cardInfo.currency,
              cardName: cardInfo.cardName,
              referenceId: authSetupjsonData.referenceID,
              code: authSetupjsonData.merchantCode,
              amount: cardInfo.billerInfo.amount,
              address1: cardInfo.billerInfo.address1,
              address2: cardInfo.billerInfo.address2,
              area: cardInfo.billerInfo.area,
              cardType: cardInfo.cardType,
              locality: cardInfo.billerInfo.locality,
              postalcode: cardInfo.billerInfo.postalcode,
              country: cardInfo.billerInfo.country,
              fname: cardInfo.billerInfo.fname,
              Lname: cardInfo.billerInfo.Lname,
              phone: cardInfo.billerInfo.phone,
              email: cardInfo.billerInfo.email,
              ipaddr: ipAddress, // dynamic ip address(client ip address)
              userAgentBrowserValue: navigator.userAgent,
              screenwidth: window.screen.width,
              screenheight: window.screen.height,
              browserTZ: new Date().getTimezoneOffset(),
              browserColorDepth: window.screen.colorDepth,
              browserJavaEnabled: true,
              browserJavaScriptEnabled: true,
              returnUrl:
                "https://v256.rafikii.io/?data=" +
                encodeURIComponent(JSON.stringify(cardInfo)) +
                "&referenceID=" +
                authSetupjsonData.referenceID,
            };

            try {
              const response = await fetch(chkenrollmenturl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(checkEnrollmentData),
              });
              const data = await response.json();
              if (data.isValid) {
                setEnrollmentData(data);
                sendMessageToRN({
                  action: "enrollment-check-success",
                  payload: { data, error: null },
                });

                handleOTPFlow(data, authSetupjsonData);
              }
            } catch (error) {
              console.error("Error checking enrollment:", error);
              sendMessageToRN({
                action: "enrollment-check-fail",
                payload: { data: null, error },
              });
            }
          }
        }
      };

      // Function to handle OTP flow
      const handleOTPFlow = async (data, authSetupjsonData) => {
        const { authStatus, accessToken: otpToken } = data;
        var finalpayurl;

        var paymentInfo = {
          referenceID: authSetupjsonData.referenceID,
          Code: authSetupjsonData.merchantCode,
          acsTransId: data.acsTransactionId ? data.acsTransactionId : 0,
          authTransId: data.authenticationTransactionId
            ? data.authenticationTransactionId
            : 0,
          cardData: cardInfo,
        };

        var PaymentData = {
          authAcsTransactionID: paymentInfo.acsTransId,
          authTransactionID: paymentInfo.authTransId,
          authReferenceID: paymentInfo.referenceID,
          cardNumber: paymentInfo.cardData.cardNumber,
          expYear: paymentInfo.cardData.expYear,
          expMonth: paymentInfo.cardData.expMonth,
          cardName: paymentInfo.cardData.cardName,
          address1: paymentInfo.cardData.billerInfo.address1,
          address2: paymentInfo.cardData.billerInfo.address2,
          area: paymentInfo.cardData.billerInfo.area,
          cardType: paymentInfo.cardData.cardType,
          locality: paymentInfo.cardData.billerInfo.locality,
          postalcode: paymentInfo.cardData.billerInfo.postalcode,
          country: paymentInfo.cardData.billerInfo.country,
          fname: paymentInfo.cardData.billerInfo.fname,
          Lname: paymentInfo.cardData.billerInfo.Lname,
          phone: paymentInfo.cardData.billerInfo.phone,
          email: paymentInfo.cardData.billerInfo.email,
          amount: paymentInfo.cardData.billerInfo.amount,
          currency: paymentInfo.cardData.currency,
          code: paymentInfo.Code,
          AccountNumber: paymentInfo.cardData.serviceInfo.AccountNumber,
          PayMethod: paymentInfo.cardData.serviceInfo.PayMethod,
          PayBusinessId: paymentInfo.cardData.serviceInfo.PayBusinessId,
          TransactionReference:
            paymentInfo.cardData.serviceInfo.TransactionReference,
          ClientId: paymentInfo.cardData.serviceInfo.ClientId,
          PayType: paymentInfo.cardData.serviceInfo.PayType,
          Service: paymentInfo.cardData.serviceInfo.Service,
          Description: paymentInfo.cardData.serviceInfo.Description,
          Notes: paymentInfo.cardData.serviceInfo.Notes,
        };

        sendMessageToRN({
          action: "payment-data-payload",
          payload: { data: PaymentData, error: null },
        });

        if (authStatus === "PENDING_AUTHENTICATION") {
          const otpIframe = document.createElement("iframe");
          otpIframe.width = `${window.innerWidth * 0.9}`;
          otpIframe.height = `${window.innerHeight * 0.9}`;
          otpIframe.style = "border: none; outline: none;";
          otpIframe.id = "step-up-iframe";
          otpIframe.name = "step-up-iframe";

          // iframe event listeners
          otpIframe.addEventListener("load", (e) => {
            sendMessageToRN({
              action: "otp-iframe-loaded",
              payload: {
                data: {
                  message: "otp iframe loaded",
                  event: {
                    type: e.type,
                    timeStamp: e.timeStamp,
                    isTrusted: e.isTrusted,
                    //extra: e.target,
                  },
                },
                error: null,
              },
            });
          });

          const otpIframeDiv = document.getElementById("otpIframeDiv");
          if (otpIframeDiv) {
            otpIframeDiv.appendChild(otpIframe);

            // hide the loader element
            const loaderEl = document.getElementById("loader");
            loaderEl.style = "display: none;";
            document.body.style = "background-color: white;";

            sendMessageToRN({
              action: "otp-iframe-visible",
              payload: {
                data: { message: "hide the loader animation" },
                error: null,
              },
            });
          }

          const otpIframeForm = document.createElement("form");
          otpIframeForm.id = "step-up-form";
          otpIframeForm.target = "step-up-iframe";
          otpIframeForm.method = "POST";
          otpIframeForm.action =
            "https://centinelapi.cardinalcommerce.com/V2/Cruise/StepUp";

          const otpInput = document.createElement("input");
          otpInput.name = "JWT";
          otpInput.type = "hidden";
          otpInput.value = otpToken;

          const otpMD = document.createElement("input");
          otpMD.name = "MD";
          otpMD.type = "hidden";
          otpMD.value =
            "optionally_include_custom_data_that_will_be_returned_as_is";

          otpIframeForm.appendChild(otpMD);
          otpIframeForm.appendChild(otpInput);
          if (otpIframeDiv) {
            otpIframeDiv.appendChild(otpIframeForm);
          }
          otpIframeForm.submit();

          // remove the iframe and show loader animation
          //otpIframeDiv.style = "display: none;";
          //document.body.style = "background-color: rgba(62, 78, 112, 1);";
          //const loaderEl = document.getElementById("loader");
          //loaderEl.style = "display: contents;";

          //sendMessageToRN({
          //  action: "otp-iframe-invisible",
          //  payload: {
          //   data: { message: "show the loader animation" },
          //    error: null,
          //  },
          //});
        } //otp is disabled send request for final process 0auth
        else if(authStatus === "AUTHENTICATION_SUCCESSFULL"){
          
          finalpayurl = "https://pay.rafikii.io/api/v1/card/procesfrictionlesspay";
          try {
            const response = await fetch(finalpayurl, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(PaymentData),
            });
            const finalData = await response.json();

            // handle response codes
            switch (finalData.code) {
              case 200:
                sendMessageToRN({
                  action: "success",
                  payload: { data: finalData, error: null },
                });
                break;
              case 201:
                sendMessageToRN({
                  action: "fail",
                  payload: { data: finalData, error: null },
                });
                break;
              case 214:
                sendMessageToRN({
                  action: "fail",
                  payload: { data: finalData, error: null },
                });
                break;
              default:
                sendMessageToRN({
                  action: "fail",
                  payload: { data: finalData, error: null },
                });

                break;
            }
          } catch (error) {
            console.error("Error checking enrollment:", error);

            sendMessageToRN({
              action: "fail",
              payload: { data: null, error },
            });
          }
        }
        else {
          finalpayurl = "https://pay.rafikii.io/api/v1/card/noAuthPay";
          try {
            const response = await fetch(finalpayurl, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(PaymentData),
            });
            const finalData = await response.json();

            // handle response codes
            switch (finalData.code) {
              case 200:
                sendMessageToRN({
                  action: "success",
                  payload: { data: finalData, error: null },
                });
                break;
              case 201:
                sendMessageToRN({
                  action: "fail",
                  payload: { data: finalData, error: null },
                });
                break;
              case 214:
                sendMessageToRN({
                  action: "fail",
                  payload: { data: finalData, error: null },
                });
                break;
              default:
                sendMessageToRN({
                  action: "fail",
                  payload: { data: finalData, error: null },
                });

                break;
            }
          } catch (error) {
            console.error("Error checking enrollment:", error);

            sendMessageToRN({
              action: "fail",
              payload: { data: null, error },
            });
          }
        }
      };

      if (action === "cardInfo") {
        handleCardInfo(cardInfo);
      }
    };

    // Assign the function to window object so React Native can access it
    window.onMessageFromRN = onMessageFromRN;
  }, [authSetupjsonData]);

  const noAuthPay = async (data) => {
    //construct json for payment
  };

  function sendMessageToRN(message) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
  }

  return (
    <div>
      <div id="dataCollectionIframe"></div>
      <div
        style={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingInline: 20,
        }}
        id="otpIframeDiv"
      ></div>
    </div>
  );
};

export default WebViewComponent;
